import { render, staticRenderFns } from "./NewAccountHeader.vue?vue&type=template&id=8f893e00&scoped=true&"
import script from "./NewAccountHeader.vue?vue&type=script&lang=js&"
export * from "./NewAccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountHeader.vue?vue&type=style&index=0&id=8f893e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f893e00",
  null
  
)

export default component.exports